import React from "react";
import Arrow from "../img/arrow.png";

export default function Header({ isReq, onSelect, progress = 0, dragging = false }) {
  const pillStyle = {
    transform: `translateX(${progress * 100}%)`,
    transition: dragging ? "none" : "transform 0.3s ease",
  };

  return (
    <div className="header">
      <div className="title">
        <a href="https://kaspi.kz" target="_blank" rel="noopener noreferrer">
          <img src={Arrow} alt="" className="back-icon" />
        </a>
        <h1 className="text-title" style={{ fontWeight: "bold", fontSize: "16px" }}>
          Удостоверение личности
        </h1>
      </div>
      <div className="tab">
        <div className="btntab">
          <span className="btntab-pill" style={pillStyle} />
          <input
            type="radio"
            name="tab-btn"
            id="tab-btn-1"
            value="doc"
            checked={!isReq}
            onChange={() => onSelect(false)}
          />
          <label htmlFor="tab-btn-1">
            <p>Документ</p>
          </label>
          <input
            type="radio"
            name="tab-btn"
            id="tab-btn-2"
            value="req"
            checked={isReq}
            onChange={() => onSelect(true)}
          />
          <label htmlFor="tab-btn-2">
            <p>Реквизиты</p>
          </label>
        </div>
      </div>
    </div>
  );
}
